import {
  BookOpenIcon,
  BuildingLibraryIcon,
  UserIcon,
} from "@heroicons/react/24/outline";
import { toast } from "react-toastify";
import { titles } from "../../Titles";

const BookedSpeakerCard = ({ bookedData }) => {
  const title =
    titles.find((title) => title.number === bookedData.number)?.name || "-";

  const copyCode = () => {
    const text =
      "Ομιλητής: " +
      bookedData.speakerName +
      "\n" +
      "Εκκλησία: " +
      bookedData.meetingHouse +
      "\n" +
      "Θέμα: " +
      title;
    navigator.clipboard
      .writeText(text)
      .then(() => {
        toast("📋 Αντιγράφηκε", {
          isLoading: false,
          autoClose: 700,
        });
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };
  return (
    <div className={"flex flex-col bg-white cursor-pointer text-sm gap-1"} onClick={copyCode}>
      <div className={"flex flex-row items-center gap-1"}>
        <UserIcon className={"w-4 h-4 shrink-0"} />
        <span>{bookedData?.speakerName}</span>
      </div>
      <div className={"flex flex-row items-center gap-1"}>
        <BuildingLibraryIcon className={"w-4 h-4"} />
        <span>{bookedData?.meetingHouse}</span>
      </div>
      <div className={"flex flex-row items-center gap-1"}>
        <BookOpenIcon className={"w-4 h-4"} />
        <span>{bookedData?.number}</span>
      </div>
    </div>
  );
};

export default BookedSpeakerCard;
